import React, { useEffect, useState } from "react";
import { Footer, Navbar } from "../components";
import { Route, Routes, useNavigate } from "react-router-dom";
import { Auth, API, graphqlOperation, Storage } from "aws-amplify";
import "./styles.css";

const Jobs = ({ isUserLoggedIn, setIsUserLoggedIn }) => {
  const navigate = useNavigate();
  const [jobsList, setJobsList] = useState([]);

  const getJobs = async () => {
    let idPoolUserID = await Auth.currentUserCredentials({ bypassCache: true });
    let uniqueUserId = idPoolUserID.identityId.split(":")[1];

    const get_jobs_list = `query MyQuery {
                getSsssmastertable(id: "jobs_list") {
                caa
            }
    }`;

    try {
      let result = await API.graphql(graphqlOperation(get_jobs_list));
      let temp = JSON.parse(result.data.getSsssmastertable.caa);
      setJobsList(temp);
    } catch (err) {
      alert("Error 108");
      return;
    }
  };

  useEffect(() => {
    if (isUserLoggedIn === false) {
      navigate("/");
      return;
    }

    getJobs();
  }, []);

  return (
    <>
      <Navbar
        isUserLoggedIn={isUserLoggedIn}
        setIsUserLoggedIn={setIsUserLoggedIn}
      />
      <h4
        style={{
          width: "60%",
          margin: 10,
          marginLeft: "20%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        JOBS
      </h4>
      <>
        {jobsList.map((item) => {
          return (
            <div
              key={item.id}
              className="courseListElements"
              style={{
                width: "80%",
                marginLeft: "10%",
                marginTop: 5,
                display: "flex",
                flexDirection: "row",
                marginBottom: 21,
                backgroundColor: "#f5f5f5",
                // boxShadow: 'red'
                // boxShadow: 'rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px'
              }}
            >
              <div>
                <p style={{ margin: 11 }}>{item.english}</p>
                <p style={{ margin: 11 }}>{item.hindi}</p>
              </div>
            </div>
          );
        })}
      </>
      <Footer />
    </>
  );
};

export default Jobs;
